import React, { useContext, useState } from "react";
import CommonModal, { CommonModalProps } from "./CommonModal";
import LoginForm from "./LoginForm";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import isMobile from "@src/utils/isMobile";

const ParentLoginModal = (props: CommonModalProps & { emailPrefill?: string; showCodeLogin?: boolean }) => {
  const t = useContext(TranslationContext);
  const [headerDisabled, setHeaderDisabled] = useState(false);
  const mobile = isMobile();

  return (
    <CommonModal
      fullPage={mobile.phone}
      headerText={headerDisabled ? undefined : t.translate("components.login.log_in_to_classdojo")}
      {...props}
    >
      <LoginForm
        userType="parent"
        emailPrefill={props.emailPrefill}
        closeModal={props.closeModal}
        showCodeLogin={props.showCodeLogin}
        disableHeader={setHeaderDisabled}
      />
    </CommonModal>
  );
};

export default ParentLoginModal;
